module.exports = __webpack_public_path__ + "img/cabal.270efcb0.svg";